export const FAILED = 'PageBase/failed';
export const LOADING = 'PageBase/loading';
export const SUCCESS = 'PageBase/success';
